import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PlanificationColumns from "../../../components/CustomTable/Columns/PlanificationColumns";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { useFeedBack } from "../../../context/FeedBackContext";
import useAxios from "../../../hooks/useAxios";
import usePlanningProcesses from "../../../hooks/usePlanningProcesses";
import usePlans from "../../../hooks/usePlans";
import useModulePlans from "../../../hooks/useModulePlans";
import PlansColumns from "../../../components/CustomTable/Columns/PlansColumns";
import AsyncSelect from "react-select/async";
import handleLoadSelectOptions from "../../../util/handleLoadSelectOptions";
import mapValues from "../../../util/mapValues";
import useCostCenters from "../../../hooks/useCostCenters";
import useUsers from "../../../hooks/useUsers";

const Plans = () => {

    const entity = {
        name: 'Planes',
        url: 'module-plans',
        frontendUrl: '/planes',
        camelName: 'plans',
    };

    const { setCustomAlert, setLoading } = useFeedBack();

    const [filters, setFilters] = useState({
        page: 1,
        year: '',
        cost_center_id: '',
        cost_center_code: '',
        status: '',
        approved_by_id: '',
        closed_at_start: '',
        closed_at_end: '',
        approved_at_start: '',
        approved_at_end: '',
        created_at_start: '',
        created_at_end: '',
        orderBy: 'created_at,DESC'
    });

    const [yearsOptions, setYearsOptions] = useState([]);

    const [selectedValues, setSelectedValues] = useState([]);

    const [selectAll, setSelectAll] = useState(false);

    const [{ [entity.camelName]: records, total, numberOfPages, loading }, getRecords] = useModulePlans({ params: { ...filters }, options: { useCache: false } });

    const [{ costCenters, loading: loadingCostCenters }, getCostCenters] = useCostCenters({ options: { useCache: false } });

    const [{ users, loading: loadingUsers }, getUsers] = useUsers({ options: { useCache: false } });

    const [{ error: deleteError, loading: deleteLoading }, deleteRecord] = useAxios({ method: 'DELETE' }, { manual: true, useCache: false });

    useEffect(() => {
        getRecords({
            params: filters
        });
    }, [filters])

    useEffect(() => {
        setLoading?.({
            show: deleteLoading,
            message: 'Eliminando Registros'
        })
    }, [deleteLoading])

    useEffect(() => {
        if (deleteError) {
            setCustomAlert({
                title: 'error',
                severity: 'danger',
                message: 'Ha ocurrido un error al eliminar.',
                show: true
            });
        }
    }, [deleteError])

    useEffect(() => {
        if (selectAll) {
            setSelectedValues(records?.map?.((value) => value?.id))
        } else {
            setSelectedValues([])
        }
    }, [selectAll])

    useEffect(() => {

        var year = new Date().getFullYear();

        var yearsBack = year - 50;

        var yearsNext = year + 50;

        var years = [];

        for (let index = yearsBack; index < yearsNext; index++) {
            years.push(index);
        }

        setYearsOptions(years);
    }, [])

    const handleDelete = (value) => {
        deleteRecord({ url: `${entity.url}/${value?.id}` }).then((data) => {
            setCustomAlert({
                title: '¡Operación Exitosa!',
                severity: 'success',
                message: 'El registro ha sido eliminado exitosamente.',
                show: true
            });
            getRecords();
        })
    }

    const handleSelectALL = () => {
        setSelectAll((oldSelectAll) => !oldSelectAll);
    }

    const handleSelectValue = (selectedValue) => {
        const value = selectedValues?.includes(Number(selectedValue?.id));
        if (value) {
            const newValues = selectedValues?.filter(n => n !== Number(selectedValue?.id));
            setSelectedValues(newValues);
        } else {
            setSelectedValues((oldSelectedValues) => [...oldSelectedValues, Number(selectedValue?.id)])
        }
    }

    const handlePageChange = (page) => {
        if (numberOfPages >= page && page > 0) {
            setFilters((oldFilters) => {
                return {
                    ...oldFilters,
                    page: page
                }
            })
        }
    }

    const handleDeleteSelected = () => {
        deleteRecord({ url: `${entity.url}/multiple`, data: { ids: selectedValues } }).then((data) => {
            setCustomAlert({
                title: '¡Operación Exitosa!',
                severity: 'success',
                message: 'Los registros han sido eliminados exitosamente.',
                show: true
            })
            setSelectedValues([]);
            getRecords();
        });
    }

    const handleChange = (e) => {
        setFilters((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    return (
        <div>
            <div className="my-4 justify-content-end d-flex">
                {
                    <>
                        <Link to={`${entity.frontendUrl}/crear`} className="btn btn-primary">
                            Crear {entity.name}
                        </Link>
                    </>
                }
            </div>
            <div className="row">
                <div className="col-md-2 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Año:
                        </label>
                        <select
                            value={filters?.year}
                            className="form-control"
                            name="year"
                            onChange={handleChange}
                        >
                            <option value="">Seleccione una opción</option>
                            {
                                yearsOptions.map((year, i) => {
                                    return (
                                        <option value={year} key={i}>{year}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Código Centro De Costo
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.cost_center_code}
                            name="cost_center_code"
                            placeholder="Ej: SSM99345..."
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Centro de costo
                        </label>
                        <AsyncSelect
                            isClearable
                            onFocus={() => {
                                getCostCenters({ params: { perPage: 50 } });
                            }}
                            defaultOptions={mapValues(costCenters)}
                            isLoading={loadingCostCenters}
                            loadOptions={(e) => handleLoadSelectOptions(e, getCostCenters, { perPage: 50 })}
                            placeholder='Escriba el nombre para buscar...'
                            onChange={(e) => { handleChange({ target: { value: e?.value, name: 'cost_center_id' } }) }}
                        />
                    </div>
                </div>
                <div className="col-md-2 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Estado
                        </label>
                        <select name="status" className="form-control" value={filters?.status} onChange={handleChange}>
                            <option value="">Seleccione una opción</option>
                            <option value="CLOSED">Cerrado</option>
                            <option value="OPEN">Abierto</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-2 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Aprobador
                        </label>
                        <AsyncSelect
                            isClearable
                            onFocus={() => {
                                getUsers({ params: { perPage: 50 } });
                            }}
                            defaultOptions={mapValues(users)}
                            isLoading={loadingUsers}
                            loadOptions={(e) => handleLoadSelectOptions(e, getUsers, { perPage: 50 })}
                            placeholder='Escriba el nombre...'
                            onChange={(e) => { handleChange({ target: { value: e?.value, name: 'approved_by_id' } }) }}
                        />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Fecha de cierre
                        </label>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Desde</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.closed_at_start}
                                    name="closed_at_start"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Hasta</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.closed_at_end}
                                    name="closed_at_end"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Fecha de aprobación
                        </label>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Desde</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.approved_at_start}
                                    name="approved_at_start"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Hasta</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.approved_at_end}
                                    name="approved_at_end"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="form-group card p-2">
                        <label className="text-primary fw-bold">
                            Fecha de creación
                        </label>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Desde</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.created_at_start}
                                    name="created_at_start"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="text-primary">Hasta</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.created_at_end}
                                    name="created_at_end"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CustomTable
                onDeleteSelected={handleDeleteSelected}
                onSelectValue={handleSelectValue}
                onSelectAll={handleSelectALL}
                loading={loading}
                selectAll={selectAll}
                title={entity?.name}
                entity={entity.url}
                updatePath={entity.frontendUrl}
                updateOptionString={'Detalles'}
                onDelete={handleDelete}
                selectedValues={selectedValues}
                pages={numberOfPages}
                total={total}
                values={records}
                currentPage={filters?.page}
                collumns={PlansColumns}
                changePage={handlePageChange}
                filters={filters}
                excelUrl={`${entity.url}/export/excel`}
                perPage={filters?.perPage}
                onPerPageChange={(e) => setFilters((oldFilters) => {
                    return {
                        ...oldFilters,
                        [e.target.name]: e.target.value
                    }
                })}
            />
        </div>
    )
}

export default Plans;